import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import Navigator from './Navigator';
import Pathfinder from './Pathfinder';
import Resources from './Resources';
import About from './About';
import Legal from './Legal';
import Footer from './Footer'; // Import the Footer component
import './App.css';
import './Responsive.css';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar bg="light" expand="lg" className="mb-4 card-coastal">
          <Container>
            <Navbar.Brand as={Link} to="/">
              <img
                src="/lonesailorlogo.png"
                width="30"
                height="30"
                className="d-inline-block align-top"
                alt="ComRelAI Logo"
              />{' '}
              ComRelAI
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/">The Navigator</Nav.Link>
                <Nav.Link as={Link} to="/pathfinder">The Pathfinder</Nav.Link>
                <Nav.Link as={Link} to="/resources">Resources & Waypoints</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Navigator />} />
            <Route path="/pathfinder" element={<Pathfinder />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/legal" element={<Legal />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;